import React from 'react'
import Sidebar from './Sidebar'


import './contacts.css'
function Contact() {
  return (
    <div className='main_conatiner'>
    
      <Sidebar/>
     
    </div>
  )
}

export default Contact